export {};
//////
//# sourceMappingURL=shape-primitives.js.map